export const PASSWORD_MIN_LENGTH = 8;

export const initialFields = {
  fullName: '',
  email: '',
  emailConfirmation: '',
  password: '',
  passwordConfirmation: '',
  branchId: null,
  teamIds: [],
  canViewOtherBranches: false,
  inquiryBranchIds: [],
  permissionGroupIds: [],
};

const initialState = {
  fields: initialFields,
  submitStatus: 'idle',
  serverErrors: {},
  // Emails the backend already rejected, with its message. There's no
  // endpoint to check an email up front, so retrying one is blocked here.
  rejectedEmails: {},
};

export default initialState;
